<template>
  <div class="center-news">
    <LevalMenu :LevalMenu="LevalMenu" :indexShow = 'IntroductData'></LevalMenu>
    <newsList :newscid='newsCid' :indexShow = 'IntroductData'/>
  </div>
</template>

<script>
import LevalMenu from '@/components/common/PositeLeval.vue'
import newsList from '@/components/join/newsList.vue'
export default {
  metaInfo () {
    return {
      title: this.title,
      meta: [{
        name: 'keyWords',
        content: this.keyWords
      },
      {
        name: 'description',
        content: this.description
      }]
    }
  },
  data () {
    return {
      newsCid: 108,
      IntroductData: {},
      LevalMenu: {},
      title: '',
      keyWords: '',
      description: ''
    }
  },
  components: {
    LevalMenu,
    newsList
  },
  methods: {
    async getData () {
      const { data: res2 } = await this.$http.get('/fdata/category?catid=107')
      const { data: res3 } = await this.$http.get('/fdata/category?catid=108')

      if (res2.code === 1) {
        this.LevalMenu = res2.data[0]
        this.IntroductData = res3.data[0]
        this.title = res3.data[0].seotitle
        this.keyWords = res3.data[0].seokeywords
        this.description = res3.data[0].seodescription
      }
    }
  },
  mounted () {
    this.getData()
  }
}
</script>

<style lang="less" scoped>
@import url("@/assets/css/news/index.less");
</style>
